import type { InferGetStaticPropsType } from 'next';
import type { ReactElement } from 'react';

import BlogPost from '@/components/Blog/BlogPost';
import Layout from '@/components/Landing/Layout';
import { getStaticBlogPaths, getStaticBlogProps } from '@/utils/getStaticBlog';

const AiCompanySlug = ({
  postData,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  return <BlogPost postData={postData} blogType="AICOMPANY" />;
};

export default AiCompanySlug;

AiCompanySlug.getLayout = (page: ReactElement) => (
  <Layout theme="light">{page}</Layout>
);

export const getStaticPaths = async () => {
  const { allResults } = await getStaticBlogPaths({ blogType: 'AICOMPANY' });

  return {
    paths: allResults.map((slug) => ({
      params: { slug: slug.toString() },
    })),
    fallback: 'blocking',
  };
};

export const getStaticProps = async ({
  params,
}: {
  params: { slug: string };
}) => {
  const { postData } = await getStaticBlogProps({
    slug: params.slug,
    blogType: 'AICOMPANY',
  });

  if (!postData)
    return {
      notFound: true,
    };

  return {
    props: {
      postData,
    },
    revalidate: 60 * 24 * 30,
  };
};
